import { ROUTE } from 'constant';
import React from 'react';
import { ACTIONS_TYPES } from 'redux/local';
import Section from 'screens/shared/section';
import { createLink, extractServerId } from 'utils';
import CreateForm from './create';

export default ({
  nics = [], history = {}, readonly = false, dcId, serverId,
}) => {
  const clickHandler = ({ id, href }) => {
    if (!serverId) serverId = extractServerId(href);
    history.push(createLink(ROUTE.DASHBOARD.NIC, { dcId, serverId, id }));
  };

  return (
    <Section
      sectionTitle="NICs"
      isAddButton={!readonly}
      createForm={<CreateForm />}
      createActionType={ACTIONS_TYPES.NIC.CREATE}
      items={nics}
      itemIcon="ethernet"
      setItemIconText={(e) => `LAN ${e?.properties?.lan}`}
      setItemTitle={(e, index) => (e?.properties?.name ? `${e?.properties?.name} - NIC ${index}` : `NIC ${index}`)}
      setItemDetails={(e) => !!e?.properties?.ips?.length && (
        `${e?.properties?.ips[0]} ${e?.properties?.ips?.length > 1 ? `+ ${e?.properties?.ips?.length - 1} more` : ''}`
      )}
      itemOnClick={clickHandler}
      className="p-t-40"
    />
  );
};
